import React, { memo, useMemo } from 'react';
import { Accordion } from 'react-bootstrap';
import EChartsReact from 'echarts-for-react';
import { stillageTypes } from 'services/stillageDashboard';
import PropTypes from 'prop-types';

const TypeSummaryAccordian = ({ data }) => {
    const pieData = useMemo(() => Object.values(
        data.reduce((acc, { stillageTypeName }) => {
            if (!stillageTypeName) return acc;

            if (!acc[stillageTypeName]) {
                acc[stillageTypeName] = {
                    name: stillageTypes[stillageTypeName]?.text ?? stillageTypeName,
                    value: 0,
                    itemStyle: {
                        color: stillageTypes[stillageTypeName]?.colour ?? '#999'
                    }
                };
            }

            acc[stillageTypeName].value += 1;
            return acc;
        }, {})
    ), [data]);

    return (
        <Accordion flush>
            <Accordion.Item eventKey="0">
                <Accordion.Header><h5>Type Summary</h5></Accordion.Header>
                <Accordion.Body>
                    <EChartsReact
                        style={{ height: '100%' }}
                        option={{
                            legend: {
                                top: '0',
                                left: 'left',
                            },
                            series: [
                                {
                                    name: 'Types',
                                    type: 'pie',
                                    radius: ['40%', '70%'],
                                    left: '0',
                                    center: ['50%', '60%'],
                                    avoidLabelOverlap: true,
                                    padAngle: 5,
                                    itemStyle: {
                                        borderRadius: 10
                                    },
                                    label: {
                                        show: false,
                                        position: 'center',
                                        fontWeight: 'bold'
                                    },
                                    labelLine: {
                                        show: false
                                    },
                                    emphasis: {
                                        label: {
                                            show: true,
                                            formatter: '{b}: {c}'
                                        }
                                    },
                                    data: pieData
                                }
                            ]
                        }} />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

TypeSummaryAccordian.propTypes = {
    data: PropTypes.array,
};

export default memo(TypeSummaryAccordian);